import { render } from "./DevicesTable.vue?vue&type=template&id=0fc223a6&scoped=true"
import script from "./DevicesTable.vue?vue&type=script&lang=js"
export * from "./DevicesTable.vue?vue&type=script&lang=js"

import "./DevicesTable.vue?vue&type=style&index=0&id=0fc223a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fc223a6"]])

export default __exports__